import React, { useEffect } from "react";
import { Paper, withStyles, Grid, Typography } from "@material-ui/core";
import { BackButton, hasPermission, parseURL } from '../../../sc-utilities';
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "../store/prepaidBalanceActions";
import History from "../../../../History";
import TopUpForm from './TopUpForm';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1),
            margin: theme.spacing(1),
            paddingRight: 0,
        }
    },
    customTooltip: {
        marginLeft: -16,
    },
    componentName: {
        display: 'flex',
        margin: 'auto',
        width: 'auto',
    },
    typography: {
        marginTop: theme.spacing(1.4),
        fontSize: '120%'
    }
});

const TopUpCreate = props => {
    const { classes, activeCustomerID, translations, onBalanceList, onBalanceCount, permissions, onCreateTopUp } = props;

    const accountID = parseURL(window.location.href).accountID;

    const handleSubmit = async data => {
        let Topups = [
            { Unit: 'work', Credits: 0 },
            { Unit: 'work_verifier', Credits: 0 },
            { Unit: 'work_diagnose', Credits: 0 },
            { Unit: 'work_check', Credits: 0 },
            { Unit: 'mobile', Credits: 0 },
            { Unit: 'mobile_erasure_lite', Credits: 0 },
            { Unit: 'mobile_verifier', Credits: 0 },
            { Unit: 'mobile_diagnose', Credits: 0 },
            { Unit: 'mobile_check', Credits: 0 },
            { Unit: 'watch', Credits: 0 },
            { Unit: 'watch_diagnose', Credits: 0 },
            { Unit: 'watch_check', Credits: 0 },
            { Unit: 'headphone_diagnose', Credits: 0 },
            { Unit: 'headphone_check', Credits: 0 },
            { Unit: 'remote', Credits: 0 },
            { Unit: 'currency', Credits: 0 }
        ];

        if (data.PromotionCredits || (data?.['Work Erasure']?.price > 0 || data?.['Work Diagnose']?.price > 0 || data?.['Work Check']?.price > 0 || data?.['Mobile Erasure']?.price > 0 || data?.['Mobile Erasure Lite']?.price > 0 || data?.['Mobile Diagnose']?.price > 0 || data?.['Mobile Check']?.price > 0 || data?.['Watch Erasure']?.price > 0 || data?.['Watch Diagnose']?.price > 0 || data?.['Watch Check']?.price > 0 || data?.['Headphone Diagnose']?.price > 0 || data?.['Headphone Check']?.price > 0 || data?.Remote?.price > 0 || data?.Currency?.price > 0 || data?.['Work Erasure Verification']?.price > 0 || data?.['Mobile Erasure Verification']?.price > 0)) {
            Topups = [
                { Unit: 'work', Credits: data?.['Work Erasure']?.amount },
                { Unit: 'work_verifier', Credits: data?.['Work Erasure Verification']?.amount },
                { Unit: 'work_diagnose', Credits: data?.['Work Diagnose']?.amount },
                { Unit: 'work_check', Credits: data?.['Work Check']?.amount },
                { Unit: 'mobile', Credits: data?.['Mobile Erasure']?.amount },
                { Unit: 'mobile_erasure_lite', Credits: data?.['Mobile Erasure Lite']?.amount },
                { Unit: 'mobile_verifier', Credits: data?.['Mobile Erasure Verification']?.amount },
                { Unit: 'mobile_diagnose', Credits: data?.['Mobile Diagnose']?.amount },
                { Unit: 'mobile_check', Credits: data?.['Mobile Check']?.amount },
                { Unit: 'watch', Credits: data?.['Watch Erasure']?.amount },
                { Unit: 'watch_diagnose', Credits: data?.['Watch Diagnose']?.amount },
                { Unit: 'watch_check', Credits: data?.['Watch Check']?.amount },
                { Unit: 'headphone_diagnose', Credits: data?.['Headphone Diagnose']?.amount },
                { Unit: 'headphone_check', Credits: data?.['Headphone Check']?.amount },
                { Unit: 'remote', Credits: data?.Remote?.amount },
                { Unit: 'currency', Credits: data?.Currency?.amount }
            ]
        }

        const result = await onCreateTopUp({
            Topups,
            PromotionCredits: data.PromotionCredits,
            ActiveAccountID: accountID,
            ActiveCustomerID: activeCustomerID
        });
        if (result) {
            History.goBack();
        }
    };

    useEffect(() => {
        const getBalanceCount = async () => {
            await onBalanceCount({ ActiveCustomerID: activeCustomerID, ActiveAccountID: accountID });
        };
        const getBalanceList = async () => {
            await onBalanceList({ ActiveCustomerID: activeCustomerID, ActiveAccountID: accountID });
        };
        getBalanceCount();
        getBalanceList();

        // eslint-disable-next-line
    }, [accountID, activeCustomerID]);

    const cancelHandler = () => {
        History.goBack();
    };

    let initialValues = {
        'Mobile Erasure': { amount: 0, price: 0, total: 0 },
        'Mobile Erasure Lite': { amount: 0, price: 0, total: 0 },
        'Mobile Erasure Verification': { amount: 0, price: 0, total: 0 },
        'Mobile Diagnose': { amount: 0, price: 0, total: 0 },
        'Mobile Check': { amount: 0, price: 0, total: 0 },
        'Work Erasure': { amount: 0, price: 0, total: 0 },
        'Work Erasure Verification': { amount: 0, price: 0, total: 0 },
        'Work Diagnose': { amount: 0, price: 0, total: 0 },
        'Work Check': { amount: 0, price: 0, total: 0 },
        'Watch Erasure': { amount: 0, price: 0, total: 0 },
        'Watch Diagnose': { amount: 0, price: 0, total: 0 },
        'Watch Check': { amount: 0, price: 0, total: 0 },
        'Headphone Diagnose': { amount: 0, price: 0, total: 0 },
        'Headphone Check': { amount: 0, price: 0, total: 0 },
        Remote: { amount: 0, price: 0, total: 0 },
        Currency: { amount: 0, price: 0, total: 0 },
        PromotionCredits: false
    };

    const validationShape = Yup.object().shape(
        {
            amount: Yup.number().integer().required(),
            price: Yup.number(),
            total: Yup.number().required()
        }
    )

    let formSettings = {
        Validation: Yup.object().shape({
            PromotionCredits: Yup.boolean().notRequired(),
            'Work Erasure': validationShape,
            'Work Erasure Verification': validationShape,
            'Work Diagnose': validationShape,
            'Work Check': validationShape,
            'Mobile Erasure': validationShape,
            'Mobile Erasure Lite': validationShape,
            'Mobile Erasure Verification': validationShape,
            'Mobile Diagnose': validationShape,
            'Mobile Check': validationShape,
            'Watch Erasure': validationShape,
            'Watch Diagnose': validationShape,
            'Watch Check': validationShape,
            'Headphone Diagnose': validationShape,
            'Headphone Check': validationShape,
            Remote: validationShape,
            Currency: Yup.object().shape(
                {
                    amount: Yup.number().notRequired().test(
                        "maxDigitsAfterDecimal",
                        "Money amount must not have more than 2 decimals",
                        (number) => /^-?\d+(\.\d{1,2})?$/.test(number)
                    ),
                    price: Yup.number(),
                    total: Yup.number()
                }
            )
        }).test((values) => Object.keys(values).some((v) => values[v].price !== 0)),
        FormTitle: translations["create_topup"] || "Create topup",
        ButtonSubmit: hasPermission(permissions, "topup_create") ? {
            Title: translations["create"] || "Create",
            Color: 'primary'
        } : null,
        ButtonCancel: {
            Title: translations["cancel"] || "CANCEL",
            handleCancel: cancelHandler
        }
    };

    return (
        <Paper className={classes.root}>
            <div className={classes.componentName}>
                {BackButton(translations, classes.customTooltip)}
                <Typography className={classes.typography}>{translations["create_topup"] || 'Create Topup'}</Typography>
            </div>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    <TopUpForm
                        accountID={accountID}
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        translations={translations}
                        permissions={permissions}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateTopUp: params => dispatch(actions.createTopUp(params)),
        onBalanceCount: params => dispatch(actions.fetchPrepaidBalanceCount(params)),
        onBalanceList: params => dispatch(actions.fetchPrepaidBalance(params)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TopUpCreate));